import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const MealIngredientUnitTable = props => {
  const { data } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Title Single</TableCell>
                  <TableCell>Title Plural</TableCell>
                  <TableCell>Level</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data && data.map(unit => (
                  <TableRow className={'table-row'} key={unit.id} hover>
                    <TableCell>{unit.id}</TableCell>
                    <TableCell>{unit.titleSingle}</TableCell>
                    <TableCell>{unit.titlePlural}</TableCell>
                    <TableCell>{unit.level}</TableCell>
                    <TableCell>{unit.active ? 'TRUE' : 'FALSE'}</TableCell>
                    <TableCell>{formatDateTime(unit.createdAt)}</TableCell>
                    <TableCell>
                      <EditBtn history={props.history} path={`/meal-ingredient/unit/edit/${unit.id}`} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  )
}

export default MealIngredientUnitTable